import React, {ReactElement} from 'react';
import MComponent from '../../Toolkit/Components/Component';
import StatusIndicator from './StatusIndicator';
import {Button} from 'primereact/button';
import {classNames} from 'primereact/utils';
import {MNullable} from '../../Toolkit/Utils';

/** */
type Props = {
    size: number;
    initialValue: number;
    onClick?: () => void;
    flat?: boolean;
    rounded?: boolean;
    outlined?: boolean;
    color?: string
    label: string;
    startDate?: Date;
    expiryDate: MNullable<Date>;
}

type State = {}

class StatusControl extends MComponent<Props, State> {

    public constructor(props: Props) {
        super(props);

        this.bindMethods();
        this.initializeState();
    }

    private bindMethods(): void {

    }

    private initializeState(): void {

    }

    public render(): ReactElement {
        const color = this.props.color === undefined ? 'primary' : this.props.color;
        const size = this.props.size === undefined ? 'p-button' : `p-button-${this.props.size}`;
        const classes = classNames(`p-button-raised p-button-${color} ${size} flex-1 md:flex-none`, {
            'p-button-text': this.props.flat === undefined ? false : this.props.flat,
            'p-button-rounded': this.props.rounded === undefined ? false : this.props.rounded,
            'p-button-outlined': this.props.outlined === undefined ? false : this.props.outlined
        });
        const start = this.props.startDate?.toLocaleDateString() ?? 'N/A';
        const expiry = this.props.expiryDate === null ? 'N/A' : this.props.expiryDate.toLocaleDateString();

        return (
            <Button className={classes}
                    onClick={this.props.onClick}
                    type={"button"}
                    style={{width: `${this.props.size * 2.5}px`, display: "block"}}>
                <div >
                    <div>
                        <label >{this.props.label}</label>
                    </div>
                    <div style={{margin: "0.3rem 0 0 0"}}>
                        <StatusIndicator size={this.props.size}
                                         status={this.props.initialValue}
                                         onClick={this.props.onClick}/>
                    </div>
                    {start !== 'N/A' &&  <div>
                        <label >{start + ' -'}</label>
                    </div>}
                    <div>
                        <label >{this.props.initialValue === 2 || 6 ? expiry : 'N/A'}</label>
                    </div>
                </div>
            </Button>
        );
    }
}

export default StatusControl;